/*
    路由定义规则 type
    1：用户登录状态可以访问
    2：用户注销状态可以访问
    3：白名单
    4：黑名单
*/

const LoginRouter = {
  path: "/Login",
  meta: {title: "登录", type: "未登录"},
  component: resolve => require(["@/components/main/Login.vue"], resolve),
};

const viewh = {
  path: "/Body",
  meta: {title: "", type: "未登录"},
  component: resolve => require(["@/components/body/viewh/viewh.vue"], resolve),
  children: [
    {
      path: "/doctorgoout",
      meta: {title: "外出", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorgoout/doctorgoout.vue"], resolve)
    },
    {
      path: "/doctorforleave",
      meta: {title: "请假", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorforleave/doctorforleave.vue"], resolve)
    },
    {
      path: "/doctorapplycard",
      meta: {title: "补卡", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorapplycard/doctorapplycard.vue"], resolve)
    },
    {
      path: "/checkmanage",
      meta: {title: "考勤管理", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/checkmanage/checkmanage.vue"], resolve)
    },
    {
      path: "/approveflow",
      name: 'approveflow',
      meta: {title: "新增审批流", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/checkmanage/approveflow/approveflow.vue"], resolve)
    },
    {
      path: "/checkmanage/updateflow",
      name: 'updateflow',
      meta: {title: "编辑审批流", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/checkmanage/updateflow/updateflow.vue"], resolve)
    },
    {
      path: "/doctorjbxq",
      meta: {title: "疾病详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorjbxq/doctorjbxq.vue"], resolve)
    },
    {
      path: "/doctorypxq",
      meta: {title: "药品详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorypxq/doctorypxq.vue"], resolve)
    },
    {
      path: "/doctorhyxy",
      meta: {title: "会员协议", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorhyxy/doctorhyxy.vue"], resolve)
    },
    {
      path: "/doctorhzxx",
      meta: {title: "患者信息", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorhzxx/doctorhzxx.vue"], resolve)
    },
    {
      path: "/rotate",
      meta: {title: "抽奖", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/rotate/rotate1.vue"], resolve)
    },
    {
      path: "/choiceadd",
      meta: {title: "选择地址", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/rotate/choiceadd.vue"], resolve)
    },
    //帮助反馈
    {
      path: "/helplist",
      meta: {title: "帮助与反馈列表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/helpfeedback/helplist.vue"], resolve)
    },
    {
      path: "/helpdetail",
      name: "helpdetail",
      meta: {title: "帮助详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/helpfeedback/helpdetail.vue"], resolve)
    },
    {
      path: "/feedbackdetail",
      name: "feedbackdetail",
      meta: {title: "反馈详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/helpfeedback/feedbackdetail.vue"], resolve)
    },
    {
      path: "/doctorhelplist",
      meta: {title: "医生帮助与反馈列表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/ysdhelpfeedback/helplist.vue"], resolve)
    },
    {
      path: "/doctorhelpdetail",
      name: "doctorhelpdetail",
      meta: {title: "医生帮助详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/ysdhelpfeedback/helpdetail.vue"], resolve)
    },
    {
      path: "/doctorfeedbackdetail",
      name: "doctorfeedbackdetail",
      meta: {title: "医生反馈详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/ysdhelpfeedback/feedbackdetail.vue"], resolve)
    },
    //患者病情描述
    {
      path: "/patients",
      name: "patients",
      meta: {title: "患者病情描述", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/patients/patients.vue"], resolve)
    },
    //安卓和ios下载页
    {
      path: "/download",
      meta: {title: "安卓和ios下载页", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/downloadpage/download.vue"], resolve)
    },
    {
      path: "/appIntro",
      meta: {title: "应用介绍", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/downloadpage/appIntro.vue"], resolve)
    },
    {
      path: "/tongjiangMealAssistance",
      meta: {title: "同江助餐下载", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/downloadpage/tongjiangMealAssistance.vue"], resolve)
    },
    //鹤岗安卓和ios下载页
    {
      path: "/hgdownload",
      meta: {title: "下载", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/hgdownload/hgdownload.vue"], resolve)
    },
    //健康医疗事件
    {
      path: "/healthevent",
      meta: {title: "健康医疗事件", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/healthevent/healthevent.vue"], resolve)
    },
    //ios用的隐私政策
    {
      path: "/iospolicy",
      meta: {title: "隐私政策", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/iospolicy/iospolicy.vue"], resolve)
    },
    //浇树页面
    {
      path: "/tree",
      meta: {title: "浇树规则", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tree/tree.vue"], resolve)
    },
    //用户端操作指南
    {
      path: "/instructions",
      meta: {title: "操作指南", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/instructions/instructions.vue"], resolve)
    },
    //日本体检 高端医疗
    {
      path: "/tumour1",
      meta: {title: "日本体检高端医疗", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tumour/tumour1.vue"], resolve)
    },
    {
      path: "/tumour2",
      meta: {title: "日本体检高端医疗", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tumour/tumour2.vue"], resolve)
    },
    {
      path: "/tumour3",
      meta: {title: "日本体检高端医疗", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tumour/tumour3.vue"], resolve)
    },
    //医生端操作指南
    {
      path: "/doctorinstruct",
      meta: {title: "医生端操作指南", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctorinstruct/doctorinstruct.vue"], resolve)
    },
    //用户服务协议
    {
      path: "/agreement",
      meta: {title: "用户服务协议", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/agreement/agreement.vue"], resolve)
    },
    //隐私政策
    {
      path: "/privacy",
      meta: {title: "隐私政策", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/privacy/privacy.vue"], resolve)
    },
    {
      path: "/privacyManager",
      meta: {title: "隐私政策", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/privacy/privacy_manager.vue"], resolve)
    },
    //法律声明
    {
      path: "/legalDeclaration",
      meta: {title: "法律声明", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/legalDeclaration/legalDeclaration.vue"], resolve)
    },
    //操作视频
    {
      path: "/operatevideo",
      meta: {title: "操作视频", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/operatevideo/operatevideo.vue"], resolve)
    },
    //新闻详情
    {
      path: "/newsdetail",
      meta: {title: "新闻详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/newsdetail/newsdetail.vue"], resolve)
    },
    //设备详情
    {
      path: "/facilitydetail",
      meta: {title: "设备详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/facilitydetail/facilitydetail.vue"], resolve)
    },

    //邀请好友
    {
      path: "/invitefriends1",
      meta: {title: "邀请好友", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/invitefriends/invitefriends1.vue"], resolve)
    },
    {
      path: "/invitefriends2",
      meta: {title: "邀请好友", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/invitefriends/invitefriends2.vue"], resolve)
    },
    //购买须知
    {
      path: "/buynotice",
      meta: {title: "购买须知", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/buynotice/buynotice.vue"], resolve)
    },
    //微信代付
    {
      path: "/wxpay",
      meta: {title: "微信代付", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/wxpay/wxpay.vue"], resolve)
    },
    //支付页面
    {
      path: "/payment",
      meta: {title: "支付订单", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/payment/payment.vue"], resolve)
    },
    //支付结果
    {
      path: "/paying",
      meta: {title: "支付中", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/payment/paying.vue"], resolve)
    },
    //支付结果
    {
      path: "/paymentResult",
      meta: {title: "支付结果", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/payment/paymentResult.vue"], resolve)
    },
    //病情页面
    {
      path: "/illness",
      meta: {title: "设备详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/illness/illness.vue"], resolve)
    },
    //商品详情
    {
      path: "/commoditydetail",
      meta: {title: "商品详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/commoditydetail/commoditydetail.vue"], resolve)
    },
    //评价详情
    {
      path: "/evaluatedetail",
      meta: {title: "评价详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/commoditydetail/evaluatedetail.vue"], resolve)
    },
    // 天气
    {
      path: "/weatherdetail",
      meta: {title: "天气详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/weatherdetail/weatherdetail.vue"], resolve)
    },
    // 医生合作协议（2021.1.26）
    {
      path: "/doctoragreement",
      meta: {title: "医生合作协议", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/doctoragreement/doctoragreement.vue"], resolve)
    },
    // 告知函（2021.1.26）
    {
      path: "/informletter",
      meta: {title: "告知函", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/informletter/informletter.vue"], resolve)
    },
    // 短信服务协议（2021.1.26）
    {
      path: "/serviceagreement",
      meta: {title: "短信服务协议", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/serviceagreement/serviceagreement.vue"], resolve)
    },
    //邀请好友新页面
    {
      path: "/invitedoctor",
      meta: {title: "邀请好友新页面", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/invitedoctor/invitedoctor.vue"], resolve)
    },
    {
      path: "/invitedownload",
      meta: {title: "邀请好友新页面", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/invitedoctor/invitedownload.vue"], resolve)
    },
    {
      path: "/hospitaldetail",
      meta: {title: "医院详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/hospitaldetail/hospitaldetail.vue"], resolve)
    },
    {
      path: "/launchgame",
      meta: {title: "发射游戏", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/game/launchgame/launchgame.vue"], resolve)
    },
    {
      path: "/feedback/questionnaire",
      meta: {title: "问卷调查", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/questionnaire/index.vue"], resolve)
    },
    {
      path: "/treatment/process/jmsfybjy",
      meta: {title: "流程查询", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/treatment/process/jmsfybjy/index.vue"], resolve)
    },
    {
      path: "/treatment/process/detail",
      name: 'treatmentProcessDetail',
      meta: {title: "流程查询", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/treatment/process/processDetail.vue"], resolve)
    },
    {
      path: "/antenatal/check/timeline",
      meta: {title: "产检时间表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/antenatal/check/index.vue"], resolve)
    },
    {
      path: "/antenatal/check/detail",
      name: 'antenatalCheckDetail',
      meta: {title: "产检时间表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/antenatal/check/checkDetail.vue"], resolve)
    },
    //放心吃页面
    {
      path: "/baby/eat",
      name: 'babyEat',
      meta: {title: "宝宝放心吃", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/baby/eat.vue"], resolve)
    },
    {
      path: "/baby/categoryeat",
      name: 'categoryeat',
      meta: {title: "宝宝放心吃", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/baby/categoryeat.vue"], resolve)
    },
    {
      path: "/baby/eat_item",
      name: 'eatItem',
      meta: {title: "羊奶", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/baby/item_detail.vue"], resolve)
    },
    //孕前检查页面
    {
      path: "/prepregnancy/prepregnancy",
      meta: {title: "孕前检查清单", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/prepregnancy/prepregnancy.vue"], resolve)
    },
    {
      path: "/prepregnancy/prepregnancy_detail",
      name: 'prepregnancyDetail',
      meta: {title: "孕前检查清单", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/prepregnancy/prepregnancy_detail.vue"], resolve)
    },
    //孕育锦囊页面
    {
      path: "/prepregnancyguide/prepregnancyGuide",
      meta: {title: "孕育锦囊", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/prepregnancyguide/prepregnancyGuide.vue"], resolve)
    },
    {
      path: "/prepregnancyguide/prepregnancyGuide_detail",
      name: 'prepregnancyGuideDetail',
      meta: {title: "孕育锦囊", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/prepregnancyguide/prepregnancyGuide_detail.vue"], resolve)
    },
    //待产包页面waitingbag
    {
      path: "/waitingbag/waitingbag",
      name: 'waitingbag',
      meta: {title: "待产包", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/waitingbag/waitingbag.vue"], resolve)
    },
    //随访计划问卷
    {
      path: "/plan/pressure/questionnaire",
      meta: {title: "随访高血压问卷", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/plan/questionnaire/index.vue"], resolve)
    },
    {
      path: "/plan/diabetes/questionnaire",
      meta: {title: "随访糖尿病问卷", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/plan/questionnaire/index2.vue"], resolve)
    },
    {
      path: "/promotion/yuezi/xibao",
      meta: {title: "优惠活动", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/yuezi/xibao/index.vue"], resolve)
    },
    {
      path: "/tools/heightPrediction",
      meta: {title: "身高预测", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tools/heightPrediction.vue"], resolve)
    },
    {
      path: "/tools/babyVaccines",
      meta: {title: "宝宝疫苗", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tools/babyVaccines.vue"], resolve)
    },
    {
      path: "/tools/babyForecast",
      meta: {title: "生男女预测", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tools/babyForecast.vue"], resolve)
    },
    {
      path: "/tools/babyHeightAndWeight",
      meta: {title: "宝宝身高体重计算器", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/tools/babyHeightAndWeight.vue"], resolve)
    },
    {
      path: "/share/medicineRemind",
      meta: {title: "分享用药提醒", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/share/medicineRemind.vue"], resolve)
    },
    {
      path: "/share/productInfo",
      meta: {title: "分享商品", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/share/productInfo.vue"], resolve)
    },
    {
      path: "/jmssfybjy/antenatal/timeline",
      meta: {title: "产检时间表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/jmssfybjy/antenatal/index.vue"], resolve)
    },
    {
      path: "/jmssfybjy/antenatal/detail",
      name: 'jmssfybjyAntenatalCheckDetail',
      meta: {title: "产检时间表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/jmssfybjy/antenatal/checkDetail.vue"], resolve)
    },
    {
      path: "/map/mapDetail",
      name: 'mapDetail',
      meta: {title: "地图页", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/map/mapDetail.vue"], resolve)
    },
    //医生文章分享
    {
      path: "/article",
      meta: {title: "文章详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/media/article.vue"], resolve)
    },
    {
      path: "/video",
      meta: {title: "视频详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/media/video.vue"], resolve)
    },
    {
      path: "/watch",
      meta: {title: "一起看", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/media/watch.vue"], resolve)
    },
    {
      path: "/socialworker/serviceobject/addServiceObject",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/serviceobject/addServiceObject.vue"], resolve)
    },
    {
      path: "/socialworker/serviceRecord/addServiceRecord",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/serviceRecord/addServiceRecord.vue"], resolve)
    },
    {
      path: "/socialworker/announcement/announcementDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/announcement/announcementDetail.vue"], resolve)
    },
    {
      path: "/socialworker/announcement/addAnnouncement",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/announcement/addAnnouncement.vue"], resolve)
    },
    {
      path: "/socialworker/activity/activityDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/activity/activityDetail.vue"], resolve)
    },
    {
      path: "/socialworker/activity/addActivity",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/activity/addActivity.vue"], resolve)
    },
    {
      path: "/socialworker/groupActivity/activityDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupActivity/activityDetail.vue"], resolve)
    },
    {
      path: "/socialworker/groupActivity/addActivity",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupActivity/addActivity.vue"], resolve)
    },
    {
      path: "/socialworker/assessment/livingAbility",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessment/livingAbility.vue"], resolve)
    },
    {
      path: "/socialworker/assessment/cognitiveAbility",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessment/cognitiveAbility.vue"], resolve)
    },
    {
      path: "/socialworker/assessment/comprehensiveAbility",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessment/comprehensiveAbility.vue"], resolve)
    },
    {
      path: "/socialworker/assessment/commonAssessment",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessment/commonAssessment.vue"], resolve)
    },
    {
      path: "/socialworker/test/qrcode",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/test/qrcode.vue"], resolve)
    },
    {
      path: "/upload/test",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/upload/test.vue"], resolve)
    },
    {
      path: "/socialworker/archive/addArchive",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/archive/addArchive.vue"], resolve)
    },
    {
      path: "/socialworker/archive/archiveDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/archive/archiveDetail.vue"], resolve)
    },
    {
      path: "/socialworker/attendance/attendanceConfig",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/attendance/attendanceConfig.vue"], resolve)
    },
    {
      path: "/community/feedback/addFeedback",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/feedback/addFeedback.vue"], resolve)
    }, {
      path: "/community/governmentservice/governmentServiceDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/governmentservice/governmentServiceDetail.vue"], resolve)
    }, {
      path: "/community/activity/activityDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/activity/activityDetail.vue"], resolve)
    },
    {
      path: "/community/activity/addActivity",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/activity/addActivity.vue"], resolve)
    }, {
      path: "/community/announcement/announcementDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/announcement/announcementDetail.vue"], resolve)
    }, {
      path: "/community/questionnaire/questionnaireDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/community/questionnaire/questionnaireDetail.vue"], resolve)
    }, {
      path: "/socialworker/talentReserve/addTalentReserve",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/talentReserve/addTalentReserve.vue"], resolve)
    }, {
      path: "/volunteerservice/addService",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/volunteerservice/addService.vue"], resolve)
    }, {
      path: "/volunteerservice/serviceDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/volunteerservice/serviceDetail.vue"], resolve)
    }, {
      path: "/socialworker/volunteer/addVolunteer",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/volunteer/addVolunteer.vue"], resolve)
    }, {
      path: "/socialworker/socialOrg/addSocialOrg",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/socialOrg/addSocialOrg.vue"], resolve)
    }, {
      path: "/socialworker/policy/addPolicy",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/policy/addPolicy.vue"], resolve)
    }, {
      path: "/socialworker/commonInfo/addCommonInfo",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/commonInfo/addCommonInfo.vue"], resolve)
    }, {
      path: "/socialworker/commonInfo/commonInfoDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/commonInfo/commonInfoDetail.vue"], resolve)
    }, {
      path: "/socialworker/commonApply/addCommonApply",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/commonApply/addCommonApply.vue"], resolve)
    }, {
      path: "/socialworker/commonApply/commonApplyDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/commonApply/commonApplyDetail.vue"], resolve)
    }, {
      path: "/socialworker/cultivate/addCultivate",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/cultivate/addCultivate.vue"], resolve)
    }, {
      path: "/socialworker/cultivate/cultivateDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/cultivate/cultivateDetail.vue"], resolve)
    }, {
      path: "/socialworker/coordination/addCoordination",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/coordination/addCoordination.vue"], resolve)
    }, {
      path: "/socialworker/coordination/coordinationDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/coordination/coordinationDetail.vue"], resolve)
    }, {
      path: "/socialworker/charitableResources/addCharitableResources",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/charitableResources/addCharitableResources.vue"], resolve)
    }, {
      path: "/socialworker/charitableResources/charitableResourcesDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/charitableResources/charitableResourcesDetail.vue"], resolve)
    }, {
      path: "/socialworker/fundRecord/addFundRecord",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/fundRecord/addFundRecord.vue"], resolve)
    }, {
      path: "/socialworker/fundRecord/fundRecordDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/fundRecord/fundRecordDetail.vue"], resolve)
    }, {
      path: "/socialworker/assessmentReport/addAssessmentReport",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessmentReport/addAssessmentReport.vue"], resolve)
    }, {
      path: "/socialworker/assessmentReport/assessmentReportDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/assessmentReport/assessmentReportDetail.vue"], resolve)
    }, {
      path: "/socialworker/orgPlan/addOrgPlan",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/orgPlan/addOrgPlan.vue"], resolve)
    }, {
      path: "/socialworker/orgPlan/orgPlanDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/orgPlan/orgPlanDetail.vue"], resolve)
    }, {
      path: "/socialworker/task/addTask",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/task/addTask.vue"], resolve)
    }, {
      path: "/socialworker/task/taskDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/task/taskDetail.vue"], resolve)
    }, {
      path: "/socialworker/report/addReport",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/report/addReport.vue"], resolve)
    }, {
      path: "/socialworker/caseWork/addCaseWork",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWork/addCaseWork.vue"], resolve),
    }, {
      path: "/socialworker/caseWorkNew/addCaseWork",
      meta: {title: "个案工作", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/addCaseWork.vue"], resolve),
      children: [
        {
          path: "addPlan",
          meta: {title: "个案服务计划", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/Plan/formDialog.vue"], resolve)
        },
        {
          path: "createCaseworkAgreement",
          meta: {title: "个案服务协议", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseworkAgreement/create.vue"], resolve)
        },
        {
          path: "addRecord",
          meta: {title: "个案服务记录", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/Record/formDialog.vue"], resolve)
        },
        {
          path: "caseworkAgreementDetail",
          meta: {title: "个案服务协议", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareAdmin/caseworkAgreement.vue"], resolve)
        }
      ]
    }, {
      path: "/socialworker/caseWorkNew/assessShareResident",
      meta: {title: "个案评估", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/Assess/shareResident"], resolve)
    }, {
      path: "/socialworker/caseWorkNew/endShareResident",
      meta: {title: "结案", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/End/shareResident"], resolve)
    }, {
      path: "/socialworker/caseWorkNew/shareResident",
      meta: {title: "个案服务计划", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareResident/planList.vue"], resolve),
      children: [
        {
          path: "planDetail",
          meta: {title: "个案服务计划", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareResident/planDetail.vue"], resolve)
        },
        {
          path: "caseworkAgreementDetail",
          meta: {title: "个案服务协议", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareResident/caseworkAgreement.vue"], resolve)
        }
      ]
    }, {
      path: "/socialworker/caseWorkNew/shareAdmin",
      meta: {title: "个案服务计划", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareAdmin/planList.vue"], resolve),
      children: [
        {
          path: "planDetail",
          meta: {title: "个案服务计划", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareAdmin/planDetail.vue"], resolve)
        },
        {
          path: "caseworkAgreementDetail",
          meta: {title: "个案服务协议", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/caseWorkNew/components/shareAdmin/caseworkAgreement.vue"], resolve)
        }
      ]
    },
    {
      path: "/socialworker/groupWork/addGroupWork",
      meta: {title: "小组工作", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/addGroupWork.vue"], resolve)
    },
    {
      path: "/socialworker/groupWork/addGroupWork/plan",
      meta: {title: "计划书", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/index.vue"], resolve),
      children: [{
        path: "addDesignBrief",
        meta: {title: "设计大纲", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/addDesignBrief.vue"], resolve),
      }, {
        path: "addFinancialBudget",
        meta: {title: "财务预算", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/addFinancialBudget.vue"], resolve),
      }]
    },
    {
      path: "/socialworker/groupWork/addGroupWork/plan/detail",
      meta: {title: "计划书详情", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/detail/index.vue"], resolve),
      children: [{
        path: "addDesignBrief",
        meta: {title: "设计大纲详情", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/detail/addDesignBrief.vue"], resolve),
      }, {
        path: "addFinancialBudget",
        meta: {title: "财务预算详情", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Plan/detail/addFinancialBudget.vue"], resolve),
      }]
    },
    {
      path: "/socialworker/groupWork/addGroupWork/itemPlan",
      meta: {title: "单元计划书", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/ItemPlan/index.vue"], resolve),
      children: [{
        path: "addItemPlan",
        meta: {title: "单元计划书", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/ItemPlan/addItemPlan.vue"], resolve),
        children: [{
          path: "addActivityContent",
          meta: {title: "单元计划书", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/ItemPlan/addActivityContent.vue"], resolve),
        }]
      }]
    },
    {
      path: "/socialworker/groupWork/addGroupWork/record",
      meta: {title: "过程记录表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Record/index.vue"], resolve),
      children: [{
        path: "addRecord",
        meta: {title: "过程记录", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Record/addRecord.vue"], resolve),
        children: [{
          path: "addActivityContent",
          meta: {title: "流程记录", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Record/addActivityContent.vue"], resolve),
        }]
      }]
    },
    {
      path: "/socialworker/groupWork/addGroupWork/summary",
      meta: {title: "评估总结报告", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Summary/index.vue"], resolve)
    },
    {
      path: "/socialworker/groupWork/addGroupWork/summary/detail",
      meta: {title: "评估总结报告", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/groupWork/components/Summary/detail/index.vue"], resolve)
    },
    {
      path: "/sos/record",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/sos/record.vue"], resolve)
    }, {
      path: "/sos/location",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/sos/location.vue"], resolve)
    }, {
      path: "/weChatOfficialAccount/volunteer",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/weChatOfficialAccount/volunteer.vue"], resolve)
    }, {
      path: "/weChatOfficialAccount/charitableResourcesIntention",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/weChatOfficialAccount/charitableResourcesIntention.vue"], resolve)
    }, {
      path: "/weChatOfficialAccount/activity/list",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/weChatOfficialAccount/activity/list.vue"], resolve)
    }, {
      path: "/weChatOfficialAccount/activity/detail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/weChatOfficialAccount/activity/detail.vue"], resolve)
    }, {
      path: "/resort/addResort",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/addResort"], resolve)
    }, {
      path: "/resort/resortInfo",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/resortInfo"], resolve)
    }, {
      path: "/resort/auditRecord",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/auditRecord.vue"], resolve)
    }, {
      path: "/resort/resortDetail",
      meta: {title: "", type: "未登录"},
      keepAlive: true,
      component: resolve => require(["@/components/body/viewh/resort/resortDetail.vue"], resolve)
    }, {
      path: "/resort/resortCaseDetail",
      meta: {title: "", type: "未登录"},
      keepAlive: true,
      component: resolve => require(["@/components/body/viewh/resort/resortCaseDetail.vue"], resolve)
    }, {
      path: "/resort/addHelpRecord",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/addHelpRecord.vue"], resolve)
    }, {
      path: "/resort/cancelResort",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/cancelResort.vue"], resolve)
    }, {
      path: "/resort/agreement",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/agreement.vue"], resolve)
    }, {
      path: "/resort/merchantDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/resort/merchantDetail.vue"], resolve)
    }, {
      name: "createResidentActivity",
      path: "/socialworker/residentActivity/createActivity",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/createActivity.vue"], resolve)
    }, {
      name: "residentActivityList",
      path: "/socialworker/residentActivity/activityList",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/activityList.vue"], resolve)
    }, {
      name: "residentActivityDetail",
      path: "/socialworker/residentActivity/activityDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/activityDetail.vue"], resolve)
    }, {
      name: "residentActivitySignup",
      path: "/socialworker/residentActivity/activitySignup",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/activitySignup.vue"], resolve)
    }, {
      name: "residentActivityInstructions",
      path: "/socialworker/residentActivity/activityInstructions",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/activityInstructions.vue"], resolve)
    }, {
      name: "residentActivityMyActivity",
      path: "/socialworker/residentActivity/myActivityList",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/myActivityList.vue"], resolve)
    }, {
      name: "residentActivityRollCall",
      path: "/socialworker/residentActivity/activityRollCall",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/activityRollCall.vue"], resolve)
    }, {
      name: "residentActivitySubmitEvaluation",
      path: "/socialworker/residentActivity/submitEvaluation",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/submitEvaluation.vue"], resolve)
    }, {
      name: "residentActivityViewEvaluation",
      path: "/socialworker/residentActivity/viewEvaluation",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/viewEvaluation.vue"], resolve)
    }, {
      name: "residentActivityMerchantStep",
      path: "/socialworker/residentActivity/merchant/merchantStep",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/merchant/merchantStep.vue"], resolve)
    }, {
      name: "residentActivityCreateMerchant",
      path: "/socialworker/residentActivity/merchant/createMerchant",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/merchant/createMerchant.vue"], resolve)
    }, {
      name: "residentActivityMerchantDetail",
      path: "/socialworker/residentActivity/merchant/merchantDetail",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/residentActivity/merchant/merchantDetail.vue"], resolve)
    }, {
      path: "/treeHole",
      meta: {title: "", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/treeHole"], resolve)
    }, {
      path: "/treeHole/history/list",
      meta: {title: "历史信件", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/treeHole/history/list.vue"], resolve),
      children: [
        {
          path: "detail",
          meta: {title: "详情", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/treeHole/history/detail.vue"], resolve),
        }
      ]
    },
    {
      path: "/socialworker/helpStudent/admin",
      meta: {title: "幼苗护学", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/admin/index.vue"], resolve),
      children: [
        {
          path: "school/create",
          meta: {title: "新增学校", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/admin/school/create.vue"], resolve)
        },
        {
          path: "team/create",
          meta: {title: "新增护学队", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/admin/team/create.vue"], resolve)
        },
        {
          path: "team/detail",
          meta: {title: "护学队", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/admin/team/detail.vue"], resolve),
          children: [
            {
              path: "applyDetail",
              meta: {title: "申请详情", type: "未登录"},
              component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/admin/team/applyDetail.vue"], resolve)
            },
            {
              path: "service/addRecord",
              meta: {title: "服务记录", type: "未登录"},
              component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/service/addRecord.vue"], resolve)
            }
          ]
        },
      ]
    },
    {
      path: "/socialworker/helpStudent/resident",
      meta: {title: "幼苗护学", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/index.vue"], resolve),
      children: [
        {
          path: "team",
          meta: {title: "护学队", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/index.vue"], resolve)
        },
        {
          path: "team/detail",
          meta: {title: "护学队", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/detail.vue"], resolve)
        },
        {
          path: "team/apply",
          meta: {title: "申请", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/apply.vue"], resolve)
        },
        {
          path: "team/memberList",
          meta: {title: "队员管理", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/memberList.vue"], resolve)
        },
        {
          path: "team/service/addRecord",
          meta: {title: "服务记录", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/service/addRecord.vue"], resolve)
        },
        {
          path: "team/myApplyList",
          meta: {title: "我的申请", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/myApplyList.vue"], resolve)
        }, {
          path: "team/applyDetail",
          meta: {title: "申请详情", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/helpStudent/resident/team/applyDetail.vue"], resolve)
        },
      ]
    },
    {
      path: "/socialworker/examMenu",
      meta: {title: "考试题库", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/exam/examMenu.vue"], resolve)
    },
    {
      path: "/socialworker/communityWork",
      meta: {title: "社区工作", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/communityWork/index.vue"], resolve)
    },
    {
      path: "/socialworker/communityWork/plan",
      meta: {title: "计划书", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Plan/index.vue"], resolve),
      children: [{
        path: "addDesignBrief",
        meta: {title: "设计大纲", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Plan/addDesignBrief.vue"], resolve),
      }, {
        path: "addFinancialBudget",
        meta: {title: "财务预算", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Plan/addFinancialBudget.vue"], resolve),
      }]
    },
    {
      path: "/socialworker/communityWork/record",
      meta: {title: "过程记录表", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Record/index.vue"], resolve),
      children: [{
        path: "addRecord",
        meta: {title: "过程记录", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Record/addRecord.vue"], resolve),
        children: [{
          path: "addActivityContent",
          meta: {title: "流程记录", type: "未登录"},
          component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Record/addActivityContent.vue"], resolve),
        }]
      }]
    },
    {
      path: "/socialworker/communityWork/summary",
      meta: {title: "评估总结报告", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/communityWork/components/Summary/index.vue"], resolve)
    },
    {
      path: "/socialworker/exam",
      meta: {title: "在线练习", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/exam/examList.vue"], resolve),
      children: [{
        path: "examInfo",
        meta: {title: "试卷介绍", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/exam/examInfo.vue"], resolve)
      }, {
        path: "examDetail",
        meta: {title: "试卷详情", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/exam/examDetail.vue"], resolve),
        children: [
          {
            path: "answerSheet",
            meta: {title: "答题卡", type: "未登录"},
            component: resolve => require(["@/components/body/viewh/socialworker/exam/answerSheet.vue"], resolve)
          }
        ]
      }, {
        path: "myExamList",
        meta: {title: "做题记录", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/exam/myExamList.vue"], resolve)
      }, {
        path: "wrongQuestionList",
        meta: {title: "错题强化", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/exam/wrongQuestionList.vue"], resolve)
      }, {
        path: "wrongQuestionDetail",
        meta: {title: "试卷错题", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/exam/wrongQuestionDetail.vue"], resolve),
        children: [
          {
            path: "answerSheet",
            meta: {title: "答题卡", type: "未登录"},
            component: resolve => require(["@/components/body/viewh/socialworker/exam/answerSheet.vue"], resolve)
          }
        ]
      }]
    },
    {
      path: "/socialworker/exam/feedback/list",
      meta: {title: "反馈记录", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/exam/feedback/list.vue"], resolve),
    }, {
      path: "/socialworker/exam/feedback/create",
      meta: {title: "新增反馈", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/exam/feedback/create.vue"], resolve)
    }, {
      path: "/socialworker/interview/list",
      meta: {title: "面谈记录", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/socialworker/interview/list.vue"], resolve),
      children: [{
        path: "create",
        meta: {title: "新增面谈记录", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/interview/create.vue"], resolve)
      }, {
        path: "createCaseworkAgreement",
        meta: {title: "新增个案服务协议", type: "未登录"},
        component: resolve => require(["@/components/body/viewh/socialworker/caseworkAgreement/create.vue"], resolve)
      }]
    },{
      path: "/alarmClockSetting",
      meta: {title: "设置闹钟", type: "未登录"},
      component: resolve => require(["@/components/body/viewh/alarmClockSetting/index.vue"], resolve),
    }
  ]
};

// 所有上面定义的路由都要写在下面的routers里
const route = [
  LoginRouter,
  viewh
];

// 暴露路由
export default route;




// WEBPACK FOOTER //
// ./src/router/routes.js